import api from 'service/api'

const dponetAPI = api.create('dponet')

const departments = async ({ companyId = '' }) => {
  return await dponetAPI.get(`/companies/${companyId}/resume`)
}

export default { departments }
